import { render } from "./viewProjectCard.vue?vue&type=template&id=2d84d513&scoped=true"
import script from "./viewProjectCard.vue?vue&type=script&lang=js"
export * from "./viewProjectCard.vue?vue&type=script&lang=js"

import "./viewProjectCard.vue?vue&type=style&index=0&id=2d84d513&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d84d513"]])

export default __exports__